import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
import '@/assets/css/theme/index.css'
import request from "@/utils/request";
import engineRequest from "@/utils/engineRequest";
import Sidebar from './views/components/Sidebar.vue';
import TopBar from "@/views/components/TopBar.vue";
import RightToolbar from "@/views/components/RightToolbar.vue";
import AppFooter from "@/views/components/AppFooter.vue";

Vue.config.productionTip = false

Vue.prototype.$request = request
Vue.prototype.$baseUrl = process.env.VUE_APP_BASEURL

Vue.prototype.$engineRequest = engineRequest
Vue.prototype.$engineBaseUrl = process.env.VUE_APP_ENGINE_BASEURL


Vue.component('Sidebar', Sidebar);  // 全局注册
Vue.component('TopBar', TopBar);  // 全局注册
Vue.component('RightToolbar', RightToolbar);  // 全局注册
Vue.component('AppFooter', AppFooter);  // 全局注册
Vue.use(ElementUI, {size: "small"})


new Vue({
    router,
    render: h => h(App)
}).$mount('#app')

